<template>
  <Modal title="甄选家授权" v-model="isShow" @on-cancel="handle">
    <div class="myModal">
      <Form ref="formInfo"  :model='formInfo' label-position="right" :label-width="100" :rules="ruleValidate" @submit.native.prevent>
        <form-item label="昵称" prop="nickname">
          <Input placeholder="请输入昵称" v-model="formInfo.nickname" ></Input>
        </form-item>
        <form-item label="手机号" prop="phone">
          <Input placeholder="请输入手机号" v-model="formInfo.phone"></Input>
        </form-item>
        <form-item label="微信号" prop="wechat">
          <Input placeholder="请输入微信号" v-model="formInfo.wechat"></Input>
        </form-item>
        <FormItem label="头像" v-if="!$route.params.id">
          <div class="demo-upload-list" v-for="item in uploadList" :key="item.url" >
            <template v-if="item.status === 'finished'">
              <img :src="item.url">
              <div class="demo-upload-list-cover">
                <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
              </div>
            </template>
            <template v-else>
              <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
            </template>
          </div>
          <Upload
                  v-if="uploadList.length==0"
                  ref="uploadThumb"
                  :show-upload-list="false"
                  :on-success="handleSuccess"
                  :format="['jpg','jpeg','png','gif']"
                  :max-size="10240"
                  :on-format-error="handleFormatError"
                  :on-exceeded-size="handleMaxSize"
                  :before-upload="handleBeforeUpload"
                  type="drag"
                  :action="serverApiPic"
                  style="display: inline-block;width:58px;">
            <div style="width: 58px;height:58px;line-height: 58px;">
              <Icon type="ios-camera" size="20"></Icon>
            </div>
          </Upload>
          <Modal title="查看" v-model="visible">
            <img :src="imgUrl " v-if="visible" style="width: 100%">
          </Modal>
        </FormItem>
      </Form>
    </div>
    <div slot="footer">
      <Button type="primary"   @click="handleOk('formInfo')">确定</Button>
    </div>
  </Modal>
</template>
<style scoped>
  .myModal {
    margin-left: 20px;
    margin-top: 20px;
  }
  .demo-upload-list{
    display: inline-block;
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0,0,0,.2);
    margin-right: 4px;
  }
  .demo-upload-list img{
    width: 100%;
    height: 100%;
  }
  .demo-upload-list-cover{
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
  }
  .demo-upload-list:hover .demo-upload-list-cover{
    display: block;
  }
  .demo-upload-list-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }
</style>

<script>
import {  userEdit ,userInfo} from '@/api/user'
import Setting from '@/setting'
export default {
  name: 'userEdit',
  props: ['addShow', 'adduserid'],
  data () {
    return {
      formInfo: {
        user_id: 0,
        nickname: '',
        phone: '',
        avatar: '',
        wechat: '',

        delpics: [],
        is_official_auth: 1
      },
      uploadList: [], // 缩咯图
      server_url: Setting.serverSrc,
      serverApiPic: Setting.serverApiPic,
      isShow: false,
      imgUrl: '',
      user_id: 0,
      visible: false,
      ruleValidate: {
      }
    }
  },
  watch: {
      addShow (val) {
          // console.log(this.user_id)
          // console.log(this.formInfo.user_id)
          console.log(2222)
          if (val && this.user_id > 0 && this.user_id ==this.formInfo.user_id) {
              console.log(1111)
              this.getUserInfo()
          }
          if(this.user_id==0){
              this.formInfo.user_id = 0
              this.formInfo.nickname = ''
              this.formInfo.phone = ''
              this.formInfo.wechat = ''
              this.formInfo.avatar = 0
              this.uploadList = []
              this.formInfo.delpics = []
              this.formInfo.is_official_auth = 1
          }
          this.uploadList = []
          this.isShow = val
      },
    adduserid (val) {
      this.user_id = val
      this.formInfo.user_id = val
      console.log(val)
      if (this.user_id > 0) {
        console.log(3333)
        this.getUserInfo()
      }
    }
  },

  methods: {
    handle () {
      this.$emit('updateStatusModel2', false)
    },
    // 获取信息
    getUserInfo () {
      console.log(4444);

      userInfo(this.user_id).then(res => {
        if (res.code === 200) {
          this.formInfo=res.data;
          this.formInfo.delpics=[];
          this.uploadList.push({ 'url': this.formInfo.avatar, 'showProgress': false, 'percentage': 100, 'status': 'finished' })
          console.log(this.formInfo);
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    handleOk (name) {
      if (this.uploadList.length <= 0) {
        this.$Message.error('头像必填')
        return
      }
      this.formInfo.avatar = this.uploadList[0]['url']

      userEdit(this.formInfo).then(res => {
        if (res.code === 200) {
          let msg = '添加成功'
          this.$Message.success(msg)
          this.$emit('updateStatusModel2', false)
        }
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    handleView (url) {
      this.imgUrl = url
      this.visible = true
    },
    // 缩略图删除
    handleRemove (file) {
      const fileList2 = this.uploadList
      this.formInfo.delpics.push(file.url)
      this.uploadList.splice(fileList2.indexOf(file), 1)
      this.uploadList = []
    },
    // 缩略图
    handleSuccess (res, file) {
      let file_url = res.data.file_url
      if (file_url.substring(0, 5) === 'https') {
        file.url = file_url
      } else {
        file.url = this.server_url + file_url
      }
      this.uploadList = this.$refs.uploadThumb.fileList
    },
    handleFormatError (file) {
      this.$Message.error('文件' + file.name + '格式错误，请上传jpg或者png')
    },
    handleMaxSize (file) {
      this.$Message.error('文件' + file.name + '太大，不能大于10M')
    },
    // 缩略图
    handleBeforeUpload () {
      const check = this.uploadList.length < 1
      if (!check) {
        this.$Message.error('只能上传1张图片')
      }
      return check
    },
  }
}
</script>
